import { BCol, BRow, BText } from '@prague-digi/ui-components'
import classNames from '@prague-digi/class-names'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import arrow from '../../../../assets/pennyPayment/arrow.svg'
import number1 from '../../../../assets/pennyPayment/number1.svg'
import number2 from '../../../../assets/pennyPayment/number2.svg'
import number3 from '../../../../assets/pennyPayment/number3.svg'
import styles from './styles.scss'
import messages from '../../../../i18n'

const msg = messages.pennyPaymentConfirm.qr

export const HorizontalStepper = () => (
  <BRow>
    <BCol theme="pr-0 text-center" lg={3} xs={12}>
      <img src={number1} alt="1" />
      <br />
      <BText theme="mt-2 pb-0 mb-0">
        <FormattedMessage {...msg.step1} />
      </BText>
    </BCol>

    <BCol
      theme={classNames('d-flex col-auto justify-content-center align-items-center', styles.arrow)}>
      <img src={arrow} alt=">" />
    </BCol>

    <BCol theme="pr-0 text-center" lg={3} xs={12}>
      <img src={number2} alt="2" />
      <br />
      <BText theme="mt-2 pb-0 mb-0">
        <FormattedMessage {...msg.step2} />
      </BText>
    </BCol>

    <BCol
      theme={classNames('d-flex col-auto justify-content-center align-items-center', styles.arrow)}>
      <img src={arrow} alt=">" />
    </BCol>

    <BCol theme="pr-0 text-center" lg={3} xs={12}>
      <img src={number3} alt="3" />
      <br />
      <BText theme="mt-2 pb-0 mb-0">
        <FormattedMessage {...msg.step3} />
      </BText>
    </BCol>
  </BRow>
)

export default HorizontalStepper
